import { appBaseUrl, getModuleUrl, isElectron, tauriMode } from '@/shared/utils/import-meta'

type Protocol = 'wss:' | 'ws:' | 'http:' | 'https:'
type Params = {
  isLocal?: boolean
  protocol?: Protocol,
  pathName: string
  baseUrl?: string
}

export const getAppURL = (params: Params): string => {
  const { pathName, protocol: paramsProtocol, isLocal: isLocalResource } = params
  try {
    if (tauriMode()) {
      if (isLocalResource) {
        return pathName.startsWith('/') ? pathName : `/${pathName}`
      }
      const base = appBaseUrl()
      if (!base || base === 'False' || !/^https?:\/\//i.test(base)) {
        console.error('[getAppURL] backend base URL is not ready:', base)
        return pathName
      }
      return new URL(pathName, base.endsWith('/') ? base : `${base}/`).href
    }
    if (isElectron()) {
      if (isLocalResource) {
        const url = getModuleUrl()
        const [prePath] = url.split('/dist')
        return `${prePath}/dist/${pathName}`
      } else {
        const { origin, host } = new URL(appBaseUrl())
        if (paramsProtocol) {
          const correctProtocol = paramsProtocol.endsWith(':') ? paramsProtocol : paramsProtocol + ':'
          return new URL(pathName, `${correctProtocol}//${host}`).href
        }
        return new URL(pathName, origin).href
      }
    }
    return pathName
  } catch (e) {
    console.error(e)
    return  pathName
  }
}
